module.exports = __webpack_public_path__ + "tabletSlideLeft.png?40e8d722fa44c2293c1c8789e575194b";